/* DES Simple theme — small, dependency-free */
(function () {
  'use strict';
  var T = window.theme || { strings: {}, routes: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    function withDelims(n, prec, thou, dec) {
      thou = thou || ','; dec = dec || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0);
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2);
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(html) {
    var el = $('#Toast'); if (!el) return;
    el.innerHTML = html; el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
    $$('[data-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + count + ' items'); });
  }

  /* ---------- header: menu, dropdowns, search ---------- */
  var menuBtn = $('[data-menu-toggle]'), nav = $('#HeaderNav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
    });
  }
  $$('[data-dd-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var dd = b.closest('[data-dd]');
      var open = dd.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open);
    });
  });
  $$('details[data-dropdown]').forEach(function (d) {
    var item = d.parentElement;
    item.addEventListener('mouseenter', function () { if (isDesktop()) d.open = true; });
    item.addEventListener('mouseleave', function () { if (isDesktop()) d.open = false; });
  });
  document.addEventListener('click', function (e) {
    $$('details[data-dropdown][open]').forEach(function (d) { if (isDesktop() && !d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details[data-dropdown][open]').forEach(function (d) { d.open = false; });
    closeFacets();
    var pr = $('#PredictiveResults'); if (pr) pr.hidden = true;
  });

  var sBtn = $('[data-search-toggle]'), sBar = $('#HeaderSearch'), sInput = $('#HeaderSearchInput');
  if (sBtn && sBar) {
    sBtn.addEventListener('click', function () {
      sBar.hidden = !sBar.hidden;
      sBtn.setAttribute('aria-expanded', !sBar.hidden);
      if (!sBar.hidden && sInput) sInput.focus();
    });
  }

  /* predictive search */
  var pr = $('#PredictiveResults'), prTimer, prCtrl;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  if (sInput && pr) {
    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(prTimer);
      if (q.length < 2) { pr.hidden = true; return; }
      prTimer = setTimeout(function () {
        if (prCtrl) prCtrl.abort();
        prCtrl = 'AbortController' in window ? new AbortController() : null;
        var url = (T.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag';
        fetch(url, prCtrl ? { signal: prCtrl.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          var html = items.length ? items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=104';
            var price = p.price != null ? '$' + Number(p.price).toFixed(2).replace(/\.00$/, '') : '';
            return '<a class="pr-item" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="52" height="52" loading="lazy">' : '<span></span>') +
              '<span class="pr-title">' + esc(p.title) + '</span><span class="pr-price">' + esc(price) + '</span></a>';
          }).join('') : '<div class="pr-empty">' + (T.strings.noResults || 'No matches') + '</div>';
          html += '<a class="pr-all" href="' + (T.routes.search || '/search') + '?type=product&options[prefix]=last&q=' + encodeURIComponent(q) + '">' + (T.strings.seeAll || 'See all results') + ' for “' + esc(q) + '” →</a>';
          pr.innerHTML = html; pr.hidden = false;
        }).catch(function () {});
      }, 200);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-predictive-search]')) pr.hidden = true; });
  }

  /* ---------- AJAX add to cart ---------- */
  function ajaxAdd(form, btn) {
    var fd = new FormData(form);
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.disabled = true; }
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch((T.routes.cart || '/cart') + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        toast('✓ ' + (T.strings.added || 'Added to cart') + ' · <a href="' + (T.routes.cart || '/cart') + '">' + (T.strings.viewCart || 'View cart') + '</a>');
      })
      .catch(function (err) { toast(esc((err && (err.description || err.message)) || 'Could not add to cart')); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.disabled = false; } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-ajax-cart]') || form.matches('.buy__form')) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      ajaxAdd(form, btn);
    }
  });

  /* ---------- quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var input = b.parentElement.querySelector('input[type=number]'); if (!input) return;
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty'), 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* cart page: auto-update */
  var cartForm = $('#CartForm'), cartTimer;
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        var fd = new FormData(cartForm); fd.delete('checkout');
        var updates = fd.getAll('updates[]');
        fetch((T.routes.cart || '/cart') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates.map(Number) }) })
          .then(function () { window.location.reload(); });
      }, 500);
    });
  }

  /* ---------- collection filters ---------- */
  var facets = $('#Facets'), facetForm = $('[data-facet-form]');
  function closeFacets() { if (facets) facets.classList.remove('is-open'); }
  $$('[data-facets-open]').forEach(function (b) { b.addEventListener('click', function () { facets.classList.add('is-open'); }); });
  $$('[data-facets-close]').forEach(function (b) { b.addEventListener('click', closeFacets); });
  if (facetForm) {
    var fTimer;
    facetForm.addEventListener('change', function (e) {
      clearTimeout(fTimer);
      fTimer = setTimeout(function () {
        $$('input[type=number]', facetForm).forEach(function (i) { if (i.value === '') i.disabled = true; });
        facetForm.submit();
      }, e.target.type === 'number' ? 700 : 50);
    });
  }
  var sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      if (facetForm) {
        var h = facetForm.querySelector('input[name=sort_by]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'sort_by'; facetForm.appendChild(h); }
        h.value = sortSel.value;
        $$('input[type=number]', facetForm).forEach(function (i) { if (i.value === '') i.disabled = true; });
        facetForm.submit();
      } else {
        var u = new URL(window.location.href); u.searchParams.set('sort_by', sortSel.value); window.location = u.toString();
      }
    });
  }

  /* make filter dropdown (Shop page) */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-make-select]')) window.location.href = e.target.value;
  });

  /* ---------- product page ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var jsonEl = $('[data-product-json]', sec); if (!jsonEl) return;
    var data; try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var idInput = $('[data-variant-id]', sec);
    var addBtn = $('[data-add-button]', sec), addText = $('[data-add-text]', sec);
    var stock = $('[data-stock]', sec);

    function showMedia(id) {
      if (!id) return;
      var slide = $('.gallery__slide[data-media-id="' + id + '"]', sec); if (!slide) return;
      $$('.gallery__slide', sec).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      $$('[data-thumb]', sec).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') == id ? 'true' : 'false'); });
      var sp = slide.querySelector('[data-spin]'); if (sp) sp.dispatchEvent(new CustomEvent('spin:show'));
    }
    if (!$('.gallery__slide.is-active', sec)) { var firstSlide = $('.gallery__slide:not(.gallery__slide--spin)', sec) || $('.gallery__slide', sec); if (firstSlide) firstSlide.classList.add('is-active'); }

    /* swipe between images on phones */
    var gmain = $('[data-gallery-main]', sec);
    if (gmain) {
      var sx = null, sy = null;
      gmain.addEventListener('touchstart', function (e) { if (e.target.closest('[data-spin], model-viewer')) return; sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      gmain.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
        var thumbs = $$('[data-thumb]', sec); if (!thumbs.length) return;
        var cur = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
        var next = (cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        showMedia(thumbs[next].getAttribute('data-thumb'));
        sec.__swiped = Date.now();
      });
    }
    $$('[data-thumb]', sec).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    function currentOptions() {
      return $$('fieldset.variant-picker', sec).map(function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function updateStock(v) {
      if (!stock) return;
      var A = function (n) { return stock.getAttribute(n) || ''; };
      var th = parseInt(A('data-threshold') || '0', 10);
      var state = 'in', text = A('data-in'), sub = A('data-sub'), count = '';
      if (!v || !v.available) { state = 'out'; text = A('data-out'); sub = ''; }
      else if (v.managed && v.qty <= 0) {
        if (A('data-backorder-in') !== 'true') { state = 'order'; text = A('data-order'); sub = A('data-order-sub'); }
      }
      else if (v.managed && v.qty <= th) { state = 'low'; text = A('data-low').replace('[count]', v.qty); }
      else if (v.managed && A('data-show-count') === 'true') { count = A('data-count-text').replace('[count]', v.qty); }
      var kindOf = function (txt) {
        var t = String(txt).toLowerCase();
        if (/custom|made|build|special/.test(t)) return 'custom';
        if (/out of stock|sold out|agotado/.test(t)) return 'out';
        if (/in stock/.test(t)) return 'in';
        if (/order/.test(t)) return 'order';
        return 'custom';
      };
      if (v && v.status) {
        state = kindOf(v.status); text = v.status; count = '';
        sub = v.note || (state === 'custom' ? A('data-custom-note') : state === 'order' ? A('data-order-sub') : state === 'in' ? A('data-sub') : '');
      } else if (A('data-ov-kind')) {
        state = A('data-ov-kind'); text = A('data-ov-text'); sub = A('data-ov-note'); count = '';
      }
      stock.className = stock.className.replace(/stock--\w+/, 'stock--' + state);
      var t = $('[data-stock-text]', stock); if (t) t.textContent = text;
      var c = $('[data-stock-count]', stock); if (c) { c.textContent = count; c.hidden = !count; }
      var s2 = $('[data-stock-sub]', stock); if (s2) { s2.textContent = sub; s2.hidden = !sub; }
    }
    function onChange() {
      var opts = currentOptions();
      $$('fieldset.variant-picker', sec).forEach(function (fs, i) { var l = $('[data-selected-label]', fs); if (l) l.textContent = opts[i] || ''; });
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (idInput && v) idInput.value = v.id;
      var now = $('[data-price-now]', sec), was = $('[data-price-was]', sec);
      if (v && now) now.textContent = formatMoney(v.price);
      if (was) {
        if (v && v.compare_at_price > v.price) { was.hidden = false; was.textContent = formatMoney(v.compare_at_price); }
        else { was.hidden = true; }
      }
      var sku = $('[data-sku] span', sec); if (sku && v) sku.textContent = v.sku || '';
      if (addBtn) {
        var ok = v && v.available;
        addBtn.disabled = !ok;
        if (addText) addText.textContent = !v ? (T.strings.unavailable || 'Unavailable') : ok ? (T.strings.addToCart || 'Add to cart') : (T.strings.soldOut || 'Sold out');
      }
      updateStock(v);
      if (v && v.media_id) showMedia(v.media_id);
      if (v && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    sec.addEventListener('change', function (e) { if (e.target.closest('fieldset.variant-picker')) onChange(); });
  });

  /* ---------- media gallery lightbox ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-media-open]');
    if (btn) {
      var sec = btn.closest('section'), dlg = sec && sec.querySelector('[data-media-modal]');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var body = dlg.querySelector('[data-media-body]'), kind = btn.getAttribute('data-kind'), src = btn.getAttribute('data-src');
      var title = btn.getAttribute('data-title') || '';
      if (kind === 'embed' && src) {
        body.innerHTML = '<div class="media-modal__frame"><iframe src="' + esc(src) + '" title="' + esc(title) + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe></div>';
      } else if (kind === 'video') {
        var tpl = btn.parentElement.querySelector('[data-media-tpl]');
        body.innerHTML = tpl ? tpl.innerHTML : '';
      } else if (src) {
        body.innerHTML = '<img src="' + esc(src) + '" alt="' + esc(title) + '">';
      } else { return; }
      var t = dlg.querySelector('[data-media-title]'); if (t) t.textContent = title;
      dlg.showModal();
      return;
    }
    var dlgOpen = e.target.closest('[data-media-modal]');
    if (e.target.closest('[data-media-close]') || (dlgOpen && e.target === dlgOpen)) dlgOpen.close();
  });
  $$('[data-media-modal]').forEach(function (d) {
    d.addEventListener('close', function () { var b = d.querySelector('[data-media-body]'); if (b) b.innerHTML = ''; });
  });

  /* ---------- product image zoom (hover) ---------- */
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  $$('[data-zoom]').forEach(function (z) {
    var lens = z.querySelector('.zoom__lens');
    if (finePointer && lens) {
      z.addEventListener('mouseenter', function () {
        if (!z.__zl) { lens.style.backgroundImage = 'url("' + z.getAttribute('data-zoom-src') + '")'; z.__zl = true; }
        z.classList.add('is-zooming');
      });
      z.addEventListener('mouseleave', function () { z.classList.remove('is-zooming'); });
      z.addEventListener('mousemove', function (e) {
        var r = z.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
        var y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
        lens.style.backgroundPosition = x + '% ' + y + '%';
      });
    }
    z.addEventListener('click', function (e) {
      var sec = z.closest('[data-product-section]');
      if (sec && sec.__swiped && Date.now() - sec.__swiped < 400) return;
      openLightbox(sec, parseInt(z.getAttribute('data-index'), 10) || 0);
    });
  });

  /* ---------- product image lightbox ---------- */
  function openLightbox(sec, index) {
    if (!sec) return;
    var dlg = $('[data-lightbox]', sec), listEl = $('[data-lightbox-images]', sec);
    if (!dlg || !listEl || typeof dlg.showModal !== 'function') return;
    var imgs = []; try { imgs = JSON.parse(listEl.textContent).filter(Boolean); } catch (err) {}
    if (!imgs.length) return;
    var img = $('[data-lb-img]', dlg), count = $('[data-lb-count]', dlg), stage = $('[data-lb-stage]', dlg);
    var i = index;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      stage.classList.remove('is-zoomed'); img.style.transformOrigin = '50% 50%';
      img.src = imgs[i];
      count.textContent = (i + 1) + ' / ' + imgs.length;
      $('[data-lb-prev]', dlg).hidden = $('[data-lb-next]', dlg).hidden = imgs.length < 2;
    }
    if (!dlg.__init) {
      dlg.__init = true;
      $('[data-lb-close]', dlg).addEventListener('click', function () { dlg.close(); });
      $('[data-lb-prev]', dlg).addEventListener('click', function () { dlg.__show(dlg.__i() - 1); });
      $('[data-lb-next]', dlg).addEventListener('click', function () { dlg.__show(dlg.__i() + 1); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') dlg.__show(dlg.__i() - 1);
        if (e.key === 'ArrowRight') dlg.__show(dlg.__i() + 1);
      });
      stage.addEventListener('click', function (e) {
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        stage.classList.toggle('is-zoomed');
      });
      stage.addEventListener('mousemove', function (e) {
        if (!stage.classList.contains('is-zoomed')) return;
        var r = stage.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      var tx = null;
      stage.addEventListener('touchstart', function (e) { if (e.touches.length === 1) tx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (tx === null || stage.classList.contains('is-zoomed')) { tx = null; return; }
        var dx = e.changedTouches[0].clientX - tx; tx = null;
        if (Math.abs(dx) > 50) dlg.__show(dlg.__i() + (dx < 0 ? 1 : -1));
      });
    }
    dlg.__show = show; dlg.__i = function () { return i; };
    show(i);
    dlg.showModal();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lightbox-open]');
    if (!b) return;
    e.stopPropagation();
    openLightbox(b.closest('[data-product-section]'), parseInt(b.getAttribute('data-index'), 10) || 0);
  }, true);

  /* ---------- 360° photo spin ---------- */
  $$('[data-spin]').forEach(function (sp) {
    var frames = []; try { frames = JSON.parse(sp.getAttribute('data-frames')).filter(Boolean); } catch (err) {}
    var img = sp.querySelector('img'); if (!img || frames.length < 2) return;
    var i = 0, startX = null, startI = 0, loaded = false, played = false;
    function preload() { if (loaded) return; loaded = true; frames.forEach(function (u) { var im = new Image(); im.src = u; }); }
    function set(n) { i = ((n % frames.length) + frames.length) % frames.length; img.src = frames[i]; }
    function autoplay() {
      if (played) return; played = true; preload();
      var step = 0, total = frames.length;
      var t = setInterval(function () { set(step++); if (step > total) clearInterval(t); }, Math.max(40, 2400 / total));
    }
    sp.addEventListener('spin:show', autoplay);
    sp.addEventListener('pointerdown', function (e) { preload(); startX = e.clientX; startI = i; sp.classList.add('is-dragging'); try { sp.setPointerCapture(e.pointerId); } catch (x) {} });
    sp.addEventListener('pointermove', function (e) {
      if (startX === null) return;
      var per = Math.max(4, sp.clientWidth / frames.length / 1.2);
      set(startI - Math.round((e.clientX - startX) / per));
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { sp.addEventListener(ev, function () { startX = null; sp.classList.remove('is-dragging'); }); });
    sp.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') set(i - 1); if (e.key === 'ArrowRight') set(i + 1); });
    sp.tabIndex = 0;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { preload(); io.disconnect(); } }, { rootMargin: '200px' });
      io.observe(sp);
    }
  });

  /* ---------- 3D models (Shopify model viewer + AR) ---------- */
  if (document.querySelector('model-viewer') && window.Shopify && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures([
      { name: 'model-viewer-ui', version: '1.0', onLoad: function (err) {
        if (err) return;
        $$('model-viewer').forEach(function (mv) {
          mv.setAttribute('camera-controls', ''); mv.setAttribute('auto-rotate', ''); mv.setAttribute('interaction-prompt', 'auto');
          try { if (window.Shopify.ModelViewerUI) new window.Shopify.ModelViewerUI(mv); } catch (x) {}
        });
      } },
      { name: 'shopify-xr', version: '1.0', onLoad: function (err) {
        if (err || !window.ShopifyXR) return;
        $$('[data-product-models]').forEach(function (el) { try { window.ShopifyXR.addModels(JSON.parse(el.textContent)); } catch (x) {} });
        window.ShopifyXR.setupXRElements();
      } }
    ]);
  }

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var load = function () {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  });

  /* ---------- marketing: remember where visitors came from ---------- */
  var MK = {};
  try {
    MK = JSON.parse(sessionStorage.getItem('des_mk') || '{}');
    var qs = new URLSearchParams(window.location.search);
    if (!MK.landing) MK.landing = window.location.pathname + window.location.search;
    if (!MK.referrer && document.referrer && document.referrer.indexOf(window.location.host) === -1) MK.referrer = document.referrer;
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (qs.get(k)) MK[k] = qs.get(k); });
    sessionStorage.setItem('des_mk', JSON.stringify(MK));
  } catch (err) {}
  MK.page = window.location.href.split('?')[0];
  $$('[data-utm]').forEach(function (i) { var k = i.getAttribute('data-utm'); if (MK[k]) i.value = MK[k]; });

  function slug(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  /* footer newsletter: save "how did you find us" as a customer tag */
  var news = $('#FooterNewsletter');
  if (news) {
    news.addEventListener('submit', function () {
      var src = $('[data-source]', news), tags = $('[data-tags]', news);
      if (src && tags && src.value) tags.value = 'newsletter,source-' + slug(src.value) + (MK.utm_source ? ',utm-' + slug(MK.utm_source) : '');
    });
  }

  /* ---------- contact / lead form ---------- */
  var lead = $('[data-lead-form]') || $('#LeadForm');
  if (lead) {
    /* the Shopify form shows its own success notice after contact_posted, so only unhide this one for FormSubmit (?sent=1) */
    if (/[?&]sent=/.test(window.location.search)) {
      var ok = $('[data-lead-success]'); if (ok) { ok.hidden = false; ok.scrollIntoView({ block: 'center' }); }
    }
    var filesIn = $('[data-lead-files]', lead), list = $('[data-file-list]', lead), dz = $('[data-dropzone]', lead);
    var MAX = 10 * 1024 * 1024;
    function totalSize() { var t = 0; if (filesIn) for (var i = 0; i < filesIn.files.length; i++) t += filesIn.files[i].size; return t; }
    function renderFiles() {
      if (!filesIn || !list) return;
      var html = '';
      for (var i = 0; i < filesIn.files.length; i++) { var f = filesIn.files[i]; html += '<li>' + esc(f.name) + '<span>' + (f.size / 1048576).toFixed(1) + ' MB</span></li>'; }
      if (totalSize() > MAX) html += '<li class="is-error">Files are over 10MB total — please remove some or email them separately.</li>';
      list.innerHTML = html;
    }
    if (filesIn) {
      filesIn.addEventListener('change', renderFiles);
      if (dz) {
        ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('is-over'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('is-over'); }); });
        dz.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files.length) { try { filesIn.files = e.dataTransfer.files; } catch (x) {} renderFiles(); } });
      }
    }

    lead.addEventListener('submit', function (e) {
      if (lead.__sending) return;
      if (filesIn && totalSize() > MAX) { e.preventDefault(); renderFiles(); filesIn.closest('.field').scrollIntoView({ block: 'center' }); return; }
      e.preventDefault();
      lead.__sending = true;
      var btn = $('[data-lead-submit]', lead); if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      /* split multiple files into separate inputs so each is attached */
      if (filesIn && filesIn.files.length > 1 && window.DataTransfer) {
        try {
          var files = Array.prototype.slice.call(filesIn.files);
          files.forEach(function (f, i) {
            var dt = new DataTransfer(); dt.items.add(f);
            if (i === 0) { filesIn.files = dt.files; return; }
            var extra = document.createElement('input');
            extra.type = 'file'; extra.name = 'attachment' + (i + 1); extra.hidden = true;
            extra.files = dt.files; lead.appendChild(extra);
          });
        } catch (x) {}
      }

      /* add opted-in leads to the Shopify customer list with marketing tags */
      var tasks = [];
      var optin = $('[data-lead-optin]', lead), email = $('[data-lead-email]', lead);
      if (window.leadOptin && optin && optin.checked && email && email.value) {
        var tags = ['lead', 'contact-form'];
        $$('[data-lead-tag]', lead).forEach(function (el) {
          var key = el.getAttribute('data-lead-tag');
          if (el.type === 'radio') { if (el.checked) tags.push('lang-es'); return; }
          if (el.value) tags.push(key + '-' + slug(el.value));
        });
        if (MK.utm_source) tags.push('utm-' + slug(MK.utm_source));
        var nameEl = $('[data-lead-name]', lead), parts = nameEl ? nameEl.value.trim().split(/\s+/) : [];
        var body = new URLSearchParams();
        body.append('form_type', 'customer'); body.append('utf8', '✓');
        body.append('contact[email]', email.value);
        if (parts.length) body.append('contact[first_name]', parts.shift());
        if (parts.length) body.append('contact[last_name]', parts.join(' '));
        body.append('contact[tags]', tags.join(','));
        tasks.push(fetch('/contact#contact_form', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, redirect: 'manual' }).catch(function () {}));
      }
      var timeout = new Promise(function (res) { setTimeout(res, 2500); });
      /* requestSubmit fires a real submit event so Shopify's built-in spam protection can attach its token;
         lead.__sending makes this handler step aside the second time so the browser posts the form normally */
      Promise.race([Promise.all(tasks), timeout]).then(function () {
        if (typeof lead.requestSubmit === 'function') lead.requestSubmit();
        else HTMLFormElement.prototype.submit.call(lead);
      });
    });
  }
})();
